import styled from 'styled-components';

const AutoPayHelpDetailsWrapper = styled.div`
  display: block;
  width: 275px;
  white-space: pre-line;
  font-family: ${(props) => props.theme.font.family};
`;

const Title = styled.p`
    ${(props) => props.theme.font.subhead.v400}};        
    font-weight: bold;
    margin: 5px;
`;

const Body = styled.p`
  font-weight: ${(props) => props.theme.font.weight.v100};
  margin: 5px;

  strong {
    font-weight: bold;
  }
`;

export { AutoPayHelpDetailsWrapper, Title, Body };
